import type { Components, Theme } from '@mui/material/styles';
export const MuiAccordionDetails: Components<Theme>['MuiAccordionDetails'] = {
  styleOverrides: {
    root: ({ theme: { spacing, breakpoints } }) => ({
      paddingInline: spacing(2),
      [breakpoints.down('sm')]: {
        paddingInline: spacing(1),
      },
    }),
  },
};
